<template>
	<form @submit.prevent="createHotel()">
		<div class="row">
			<div class="col-sm-8">
				<div class="row">
					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="name"
							label="Name"
							type="text"
							v-model="data.name"
							class="form-control form-control-lg dashInput"
							:required="true"
							rules="required|min:3|max:30"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="email"
							label="Email"
							type="email"
							v-model="data.email"
							class="form-control form-control-lg dashInput"
							rules="required|email|min:3|max:30"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
						/>
					</div>
					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="contact"
							label="Contact Number"
							type="Number"
							v-model="data.phone"
							class="form-control form-control-lg dashInput"
							rules="required|min:10|max:10"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
							:min="6000000000"
							:max="9999999999"
						/>
					</div>

					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="address"
							label="Address"
							type="text"
							v-model="data.address"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
						/>
					</div>

					<div class="form-group col-sm-5 mb-6">
						<BaseMultiSelect
							@update:value="setCountry"
							:options="multiSelectState.countriesSelect"
							rules="required"
							:required="true"
							name="Country"
							@inputError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div class="form-group col-sm-5 mb-6">
						<BaseMultiSelect
							@change:value="getCities"
							@update:value="setCity"
							:options="multiSelectState.citiesSelect"
							rules="required"
							:required="true"
							name="City"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div class="form-group col-sm-2 mb-6">
						<BaseMultiSelect
							@update:value="setRating"
							:options="multiSelectState.ratings"
							rules="required"
							:required="true"
							name="Hotel Rating"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseMultiSelect
							@update:value="setAmenities"
							:options="multiSelectState.amenities"
							rules="required"
							name="Amenities"
							mode="multiple"
							:closeOnSelect="false"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>

					<div class="form-group col-sm-6 mb-4">
						<BaseMultiSelect
							@update:value="setHotelType"
							:options="multiSelectState.hotelType"
							rules="required"
							name="Hotel Type"
							mode="single"
							:required="true"
							:closeOnSelect="false"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>

					<div class="form-group col-sm-12 mb-6">
						<DynamicMultiplier
							name="HotelType"
							stateKey="roomTypes"
							state="state"
							:showName="false"
						/>
					</div>

					<div class="form-group col-sm-12 mt-4 mb-5">
						<label for="cityDataList" class="form-label small text-dark"
							>Description</label
						>
						<textarea
							class="form-control form-control-lg"
							v-model="data.description"
						></textarea>
					</div>
					<div class="col-sm-12">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="image.enabled"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Upload hotel image</label
							>
						</div>
					</div>

					<div v-if="image.enabled" class="col-sm-12">
						<BaseImageUpload urlParam="hotels" @images-data="setImage" />
					</div>
					<div
						class="form-group col-sm-6 mt-2"
						:class="formState.disable ? 'cursor-disabled' : 'cursor-pointer'"
					>
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Add Hotel"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 px-4">
				<h4 class="text-dark">Global Trip Holidays</h4>
				<p class="text-dark">
					Contacts are your customers you interact with in pursuit of a business
					opportunity.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, watch, provide } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";
	import FormCheck from "@/helpers/formCheckHelper";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseFileInput from "./BaseFileInput.vue";
	import DynamicMultiplier from "./DynamicMultiplier.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";

	export default {
		name: "HotelCreate",
		components: {
			BaseInput,
			BaseButton,
			BaseMultiSelect,
			BaseFileInput,
			DynamicMultiplier,
			BaseImageUpload,
		},
		setup: () => {
			// const masterStore = inject("masterStore");

			const data = reactive({
				name: null,
				email: null,
				phone: null,
				city: {
					id: null,
					name: null,
					state_name: null,
				},
				country: {
					id: null,
					name: null,
				},
				address: null,
				starRating: null,
				hotelType: null,
				amenities: [],
				roomTypes: [],
				description: null,
				images: [],
			});

			provide("state", data);

			const formState = reactive({
				isLoading: false,
				disable: false,
			});

			const nullable = ["hotelType", "amenities", "images"];

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
				selectedCountry: {
					id: null,
					name: null,
				},
				cities: [],
				citiesSelect: [],
				ratings: [],
				amenities: [],
				hotelType: [],
			});

			multiSelectState.ratings = Helper.rating;
			multiSelectState.amenities = Helper.amenities;
			multiSelectState.hotelType = Helper.hotelType;

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const createHotel = async () => {
				changeFormLoadingState();
				formState.disable = true;

				try {
					await API.privateRequest.post("hotels", data);
					toast.success(
						{ message: "Hotel created!", position: "topRight" },
						true,
					);
					changeFormLoadingState();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);

					changeFormLoadingState();
					formState.disable = false;
				}
			};

			// event handler for input validation event
			const inputError = (input) => {
				console.log(input);
				// let check = FormCheck.inputError(input, data, nullable);
				// formState.disable = check;
			};

			const inputSuccess = (input) => {
				// let check = FormCheck.valSuccess(input, data, nullable);
				// formState.disable = check;
			};

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;
			};

			watch(
				() => data.country,
				(newValue, preValue) => {
					getCities();
				},
				{ deep: true },
			);

			// ! City Functions

			const getCities = async (cityObj = false) => {
				let cityData = {};
				let country;

				if (cityObj?.name && cityObj.name.length < 3) return;
				else if (cityObj?.name && cityObj.name.length > 3)
					cityData.name = cityObj.name;

				if (data.country.name) {
					cityData.countryName = data.country.name;
				} else if (!cityObj && !data.country.name) return;

				try {
					const cities = await Helper.getCities(cityData);

					if (multiSelectState.cities instanceof Array)
						multiSelectState.cities = [...cities];
					else multiSelectState.cities = cities;

					const changeFormat = cities.map((city) => {
						return {
							label: `${city.name} ( ${city.state_name} )`,
							value: city.id,
						};
					});

					multiSelectState.citiesSelect = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			const setCity = (dataObj) => {
				if (!dataObj) {
					data.city.id = 0;
					data.city.name = null;
					data.city.state_name = null;
					return;
				}
				const city = multiSelectState.cities.filter(
					(city) => city.id === dataObj,
				);
				data.city.id = city[0].id;
				data.city.name = city[0].name;
				data.city.state_name = city[0].state_name;
			};
			const setRating = (dataObj) => {
				data.starRating = dataObj;
			};
			const setAmenities = (dataObj) => {
				if (!Object.keys(dataObj).length) {
					data.amenities = [];
					return;
				}
				if (data.amenities.length) {
					let found = false;
					dataObj.map((item) => {
						if (data.amenities.includes(item)) {
							return;
						} else {
							data.amenities = [...data.amenities, item];
						}
					});
				} else {
					data.amenities = [...data.amenities, ...dataObj];
				}
			};

			const setHotelType = (payload) => {
				data.hotelType = payload;
			};

			const image = reactive({
				enabled: false,
			});

			const setImage = (images) => {
				if (!images.length) return;
				data.images = [...data.images, ...images];
				formState.disable = false;
			};

			return {
				data,
				image,
				formState,
				multiSelectState,
				createHotel,
				inputError,
				inputSuccess,
				setCountry,
				getCities,
				setCity,
				setRating,
				setAmenities,
				setImage,
				setHotelType,
			};
		},
	};
</script>
